// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2cyaj","productName":"Table_productName__1ZD82"};